import axios from "axios";
const { baseurl, callFunction, callFunctionTwo, callFunctionTwoTwo, callFunctionFour } = require("./constants");

export const sendBvn = async (bvn) => {
  // console.log("BVN", bvn);
  // console.log(`${baseurl}/BVN?bVN=${bvn}`);

  const body = {
    bvn: bvn,
  };

  
const appendUrl = "BVN"

  // const response = await axios.post(
  //   `${baseurl}/BVN`,
  //   body
  // );

  const response = await callFunctionTwo(appendUrl, body)

  // console.log("RESSY",response)
  return response;
};

export const validateNIN = async (nin, IPFrontEnd) => {
  const body = {
    id: nin,
    isSubjectConsent: true,
    IPFrontEnd,
  };

  // console.log("very",body)

  const appendUrl = 'NINVerification'


  const response = await callFunction(appendUrl, body);

  // console.log("NIN-RESPONSE", response)

  return response;
};

export const sendNIN = async (nin, bvn) => {

  // console.log("CALLED HERE")
  const body = {
    nin,
    bvn,
  };

  // console.log(body)

  const appendUrl = 'NIN'

  const response = await callFunctionFour(appendUrl, body);

  // console.log
  return response;
};

export const validateBVN = async (bvn) => {
  const body = {
    bvn,
  };

  const appendUrl = 'BVNValid'

  const response = await callFunctionTwo(appendUrl, body);
  // console.log("RESPO", response?.Data)
  return response?.Data;
};
